import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
export const linkGroupMentions = function () {
  if (app.forum.attribute('canSeeUserDirectoryLink') && app.forum.attribute('userDirectoryLinkGroupMentions')) {
    // @ts-ignore
    this.$('.GroupMention').each(function () {
      // @ts-ignore
      if ($(this).hasClass('GroupMention--linked')) return;

      // @ts-ignore
      const name = $(this).find('.GroupMention-name').text();
      const group = app.store.getBy('groups', 'namePlural', name.slice(1));
      if (group) {
        const link = $(`<a class="GroupMention-link" href="${app.route('fof_user_directory', {
          q: `group:${group.id()}`
        })}"></a>`);
        link.on('click', function (e) {
          // @ts-ignore
          m.route.set(this.getAttribute('href'));
          e.preventDefault();
        });

        // @ts-ignore
        $(this).addClass('GroupMention--linked').wrap(link);
      }
    });
  }
};
export default function extendCommentPost() {
  extend(CommentPost.prototype, 'oncreate', linkGroupMentions);
  extend(CommentPost.prototype, 'onupdate', linkGroupMentions);
}
flarum.reg.add('fof-user-directory', 'forum/extenders/extendCommentPost', extendCommentPost);